var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from "@glimmer/tracking";
import { getItemFromLocalStorage, removeItemFromLocalStorage, setItemInLocalStorage } from "core/utils/use-local-storage";
let PinCodeManager = (_class = class PinCodeManager {
  // 30 min

  constructor(medic) {
    _initializerDefineProperty(this, "typedPinCode", _descriptor, this);
    _initializerDefineProperty(this, "_pinCode", _descriptor2, this);
    _defineProperty(this, "_cacheDate", void 0);
    /**
     * How much time do we keep the pin code in cache in milliseconds.
     */
    _defineProperty(this, "_cacheDuration", 1000 * 60 * 30);
    this.medic = medic;
    const cachedPinCode = getItemFromLocalStorage(this.pinCodeKey(medic));
    this._pinCode = cachedPinCode || undefined;
    const storedCacheDate = getItemFromLocalStorage(this.cacheDateKey());
    this._cacheDate = storedCacheDate ? new Date(storedCacheDate) : undefined;
  }
  get pinCode() {
    // Don't need to reset the _cacheDate as the readCpsCard function will be called just after
    if (!this.isExpired()) return this._pinCode;
    return undefined;
  }
  get isTypedPinCodeValid() {
    return pinCodeValid(this.typedPinCode);
  }
  get isStoredPinCodeValid() {
    return pinCodeValid(this.pinCode);
  }
  refreshCacheDate() {
    this._cacheDate = new Date();
  }

  /**
   * Cache the given pin code for a specific duration
   */
  cachePinCode(pinCode) {
    this._pinCode = pinCode;
    setItemInLocalStorage(this.pinCodeKey(this.medic), pinCode);
    this._cacheDate = new Date();
    setItemInLocalStorage(this.cacheDateKey(), this._cacheDate.toISOString());
  }
  resetPinCode() {
    this._pinCode = undefined;
    this.typedPinCode = undefined;
    removeItemFromLocalStorage(this.pinCodeKey(this.medic));
    this._cacheDate = undefined;
  }
  isExpired() {
    if (!this._pinCode) return false;
    if (!this._cacheDate) return false;
    return new Date().getTime() - this._cacheDate.getTime() >= this._cacheDuration;
  }
  cacheDateKey() {
    return "pin-code-manager:cache-date";
  }
  pinCodeKey(medic) {
    return `pin-code-manager:medic-${medic.id}:pin-code`;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "typedPinCode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_pinCode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { PinCodeManager as default };
function pinCodeValid(pinCode) {
  const NUMBER_OF_DIGITS = 4;
  return pinCode?.match(/^\d+$/) != null && pinCode.length === NUMBER_OF_DIGITS;
}